import React from 'react'
import { useFormContext } from 'react-hook-form'

import { Box } from 'ui/components/Box'
import { Button } from 'ui/components/Button'
import { Body } from 'ui/components/Text'

export const SaveAndDiscardFormButtons: React.FC<{ error?: string; onDelete?: () => void }> = ({
    error,
    onDelete,
}) => {
    const {
        formState: { isDirty },
        reset,
    } = useFormContext()

    return (
        <Box
            flex
            column
            py="l"
            position="sticky"
            style={{
                bottom: 0,
                left: 0,
                right: 0,
            }}
            background="surface"
        >
            <Box flex gap="s">
                <Button type="submit" size="m" variant="primary" disabled={!isDirty}>
                    Save Changes
                </Button>

                {isDirty && (
                    <Button
                        type="reset"
                        size="m"
                        variant="ghost"
                        onClick={(e) => {
                            e.preventDefault()
                            reset()
                        }}
                    >
                        Discard Changes
                    </Button>
                )}
                <Box grow />
                {onDelete && (
                    <Button type="button" size="m" variant="destructive" onClick={onDelete}>
                        Delete Agent
                    </Button>
                )}
            </Box>
            {error && (
                <Body color="textError" mt="m">
                    {error}
                </Body>
            )}
        </Box>
    )
}
